import { UUID } from '@cmg/common';
import { SnackbarManager } from '@cmg/design-system';
import React from 'react';

import { updateDemandGridRowsReactiveVar } from '../../../../../../../order-book/institutional-demand/hooks/useUpdateDemandGridRowsReactiveVar';
import { useCloseSidePanel } from '../../../../../../utils/useCloseSidePanel';
import { useIndicationActivitySyndicateContext } from '../../../../context/IndicationActivitySyndicateContext';
import { useManageIndication_DeleteIndicationMutation } from '../../graphql/__generated__';

export const useDeleteInstitutionalIndication = (indicationId: UUID, investorName: string) => {
  const { offeringId } = useIndicationActivitySyndicateContext();
  const { closeSidePanel } = useCloseSidePanel();

  const [deleteIndication, { loading }] = useManageIndication_DeleteIndicationMutation({
    variables: {
      offeringId,
      indicationId,
    },
  });

  const onDelete = React.useCallback(async () => {
    try {
      const { data } = await deleteIndication();
      updateDemandGridRowsReactiveVar({ removedIds: [data?.deleteIndication.indicationId!] });
      SnackbarManager.success(`${investorName} has been deleted.`);
      closeSidePanel();
    } catch {
      SnackbarManager.error('There was an error while deleting this indication.');
    }
  }, [closeSidePanel, deleteIndication, investorName]);

  return [onDelete, loading] as const;
};
